module.exports = __webpack_public_path__ + "static/media/images-cl_logo1.15edd926.png";